import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_plane_flight_line.svg'


const _hoisted_1 = { class: "flex items-center justify-between w-full py-2 px-3" }
const _hoisted_2 = { class: "font-medium text-left" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Tanggal keberangkatan : ")
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "flex items-center gap-x-4" }
const _hoisted_6 = {
  key: 0,
  class: "bg-orange-lp-700 text-white border border-orange-lp-100 h-5 px-2 rounded-full font-medium flex-shrink-0 flex items-center gap-x-1",
  style: {"width":"fit-content"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Maskapai ini tidak dapat kirim barang ")
const _hoisted_8 = /*#__PURE__*/_createVNode("b", null, "DG.", -1)
const _hoisted_9 = {
  key: 1,
  class: "bg-gray-lp-200 text-black-lp-300 h-5 px-2 rounded-full font-medium flex-shrink-0 flex items-center gap-x-1",
  style: {"width":"fit-content"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Sedang Diproses ")
const _hoisted_11 = {
  key: 2,
  class: "bg-gray-lp-200 text-black-lp-300 h-5 px-2 rounded-full font-medium flex-shrink-0 flex items-center gap-x-1",
  style: {"width":"fit-content"}
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Silahkan coba lagi ")
const _hoisted_13 = {
  key: 3,
  class: "bg-red-lp-600 text-red-lp-1500 h-5 px-2 rounded-full font-medium flex-shrink-0 flex items-center gap-x-1",
  style: {"width":"fit-content"}
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Tidak Tersedia ")
const _hoisted_15 = {
  key: 4,
  class: "bg-green-lp-300 text-green-lp-400 h-5 px-2 rounded-full font-medium flex-shrink-0 flex items-center gap-x-1",
  style: {"width":"fit-content"}
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Tersedia ")
const _hoisted_17 = {
  class: "bg-gray-lp-200 text-black-lp-300 h-5 px-2 rounded-full font-medium flex-shrink-0 flex items-center",
  style: {"width":"fit-content"}
}
const _hoisted_18 = { class: "border-t border-gray-lp-1400 py-2 px-3 flex flex-row items-center" }
const _hoisted_19 = {
  class: "flex-shrink-0 mr-2",
  style: {"width":"fit-content"}
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "block mb-0.5 text-left" }, "Terbang dalam", -1)
const _hoisted_21 = { class: "flex flex-row items-center relative flex-shrink-0" }
const _hoisted_22 = { class: "text-center mx-2" }
const _hoisted_23 = { class: "block text-sm font-bold" }
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "plane-line"
}, null, -1)
const _hoisted_25 = {
  key: 1,
  class: "flex flex-row items-center overflow-x-auto mx-auto"
}
const _hoisted_26 = {
  key: 0,
  class: "flex flex-row items-center px-2.5 flex-shrink-0"
}
const _hoisted_27 = { class: "block text-xl font-bold" }
const _hoisted_28 = { class: "text-sm font-bold text-left" }
const _hoisted_29 = { class: "text-center mx-2" }
const _hoisted_30 = { class: "block text-sm font-bold" }
const _hoisted_31 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "plane-line"
}, null, -1)
const _hoisted_32 = { class: "text-gray-lp-600" }
const _hoisted_33 = { class: "block text-sm font-bold" }
const _hoisted_34 = { class: "text-xs font-medium text-right" }
const _hoisted_35 = {
  key: 1,
  class: "flex flex-row items-center border-l border-gray-lp-1300 px-2.5 flex-shrink-0"
}
const _hoisted_36 = { class: "block text-sm font-bold" }
const _hoisted_37 = { class: "text-xs font-bold text-left" }
const _hoisted_38 = { class: "text-center mx-2" }
const _hoisted_39 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "plane-line"
}, null, -1)
const _hoisted_40 = { class: "block text-sm font-bold" }
const _hoisted_41 = { class: "text-xs font-medium text-right" }
const _hoisted_42 = {
  key: 2,
  class: "flex flex-row items-center px-2.5 border-l border-gray-lp-1300 flex-shrink-0"
}
const _hoisted_43 = { class: "block text-sm font-bold" }
const _hoisted_44 = { class: "text-xs font-bold text-left" }
const _hoisted_45 = { class: "text-center mx-2" }
const _hoisted_46 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "plane-line"
}, null, -1)
const _hoisted_47 = { class: "block text-xl font-bold" }
const _hoisted_48 = { class: "text-sm font-bold text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("button", {
    class: 
      `border rounded-xl text-xs w-full overflow-x-auto hover:shadow-schedule-card-v2 ${
        _ctx.statusUnavailable
          ? 'bg-gray-lp-1000 text-gray-lp-600 cursor-not-allowed'
          : _ctx.isActive
          ? 'border-red-lp-1500 bg-red-lp-50'
          : 'border-gray-lp-1400 text-gray-lp-300'
      }`
    ,
    ref: "card",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleConfirmation && _ctx.handleConfirmation(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.flightData.formattedDepartureDate), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        (_ctx.isNotSupportDg)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode(_component_Icons, {
                name: "warning-triangle-outline",
                class: "w-3 text-white"
              }),
              _hoisted_7,
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        (_ctx.loadingCheckAvailable)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode(_component_Icons, {
                name: "refresh",
                class: "w-4"
              }),
              _hoisted_10
            ]))
          : (_ctx.error)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode(_component_Icons, {
                  name: "warning-circle",
                  class: "w-4"
                }),
                _hoisted_12
              ]))
            : (_ctx.statusUnavailable)
              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                  _createVNode(_component_Icons, {
                    name: "x-circle",
                    class: "w-4"
                  }),
                  _hoisted_14
                ]))
              : (_ctx.statusAvailable)
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    _createVNode(_component_Icons, {
                      name: "check-circle",
                      class: "w-4"
                    }),
                    _hoisted_16
                  ]))
                : _createCommentVNode("", true),
        _createVNode("div", _hoisted_17, _toDisplayString(_ctx.flightData.formattedTransitNumber), 1)
      ])
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode("div", {
          class: 
            `py-0.5 px-2 font-medium rounded-2xl ${
              _ctx.statusUnavailable
                ? 'bg-white text-gray-lp-600'
                : 'bg-yellow-lp-200 text-yellow-lp-100'
            }`
          
        }, _toDisplayString(_ctx.flightData.departureAt), 3)
      ]),
      (_ctx.flightData.itineraries.length <= 1)
        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.flightData.itineraries, (itinerary, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "flex flex-row items-center justify-between mx-auto overflow-x-auto"
            }, [
              _createVNode("div", _hoisted_21, [
                _createVNode("div", {
                  class: 
                `text-sm font-bold self-baseline -mt-1 ml-1 ${
                  _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-red-lp-100'
                }`
              ,
                  style: {"align-self":"baseline","width":"50px"}
                }, null, 2),
                _createVNode("div", null, [
                  _createVNode("div", {
                    class: 
                  `block text-xl font-bold ${
                    _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-black-lp-200'
                  }`
                
                  }, _toDisplayString(_ctx.formatDateNormal(itinerary.departureDate, "HH:mm")), 3),
                  _createVNode("div", {
                    class: 
                  `text-sm font-bold text-left ${
                    _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-gray-lp-600'
                  }`
                
                  }, _toDisplayString(itinerary.originAirportCode), 3)
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, _toDisplayString(itinerary.flightNo), 1),
                  _hoisted_24
                ]),
                _createVNode("div", null, [
                  _createVNode("div", {
                    class: 
                  `block text-xl font-bold ${
                    _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-black-lp-200'
                  }`
                
                  }, _toDisplayString(_ctx.formatDateNormal(itinerary.arrivalDate, "HH:mm")), 3),
                  _createVNode("div", {
                    class: 
                  `text-sm font-bold text-right ${
                    _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-gray-lp-600'
                  }`
                
                  }, _toDisplayString(itinerary.destinationAirportCode), 3)
                ]),
                _createVNode("div", {
                  class: 
                `text-sm font-bold self-baseline -mt-1 ml-1 ${
                  _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-red-lp-100'
                }`
              ,
                  style: {"align-self":"baseline","width":"50px"}
                }, [
                  (_ctx.flightData.arrivalDays)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" +" + _toDisplayString(_ctx.flightData.arrivalDays) + " hari ", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.flightData.itineraries.length > 1)
        ? (_openBlock(), _createBlock("div", _hoisted_25, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.flightData.itineraries, (itinerary, index) => {
              return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                (index === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_26, [
                      _createVNode("div", {
                        class: 
                `${
                  _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-black-lp-200'
                }`
              
                      }, [
                        _createVNode("div", _hoisted_27, _toDisplayString(_ctx.formatDateNormal(itinerary.departureDate, "HH:mm")), 1),
                        _createVNode("div", _hoisted_28, _toDisplayString(itinerary.originAirportCode), 1)
                      ], 2),
                      _createVNode("div", _hoisted_29, [
                        _createVNode("div", _hoisted_30, _toDisplayString(itinerary.flightNo), 1),
                        _hoisted_31
                      ]),
                      _createVNode("div", _hoisted_32, [
                        _createVNode("div", _hoisted_33, _toDisplayString(_ctx.formatDateNormal(itinerary.arrivalDate, "HH:mm")), 1),
                        _createVNode("div", _hoisted_34, _toDisplayString(itinerary.destinationAirportCode), 1)
                      ])
                    ]))
                  : (
              index !== 0 && index !== _ctx.flightData.itineraries.length - 1
            )
                    ? (_openBlock(), _createBlock("div", _hoisted_35, [
                        _createVNode("div", {
                          class: 
                `${_ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-red-lp-100'}`
              
                        }, [
                          _createVNode("div", _hoisted_36, _toDisplayString(_ctx.formatDateNormal(itinerary.departureDate, "HH:mm")), 1),
                          _createVNode("div", _hoisted_37, _toDisplayString(itinerary.originAirportCode), 1)
                        ], 2),
                        _createVNode("div", _hoisted_38, [
                          _createVNode("div", {
                            class: 
                  `block text-sm font-medium ${
                    _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-gray-lp-600'
                  }`
                
                          }, _toDisplayString(itinerary.flightNo), 3),
                          _hoisted_39
                        ]),
                        _createVNode("div", {
                          class: 
                `${_ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-gray-lp-600'}`
              
                        }, [
                          _createVNode("div", _hoisted_40, _toDisplayString(_ctx.formatDateNormal(itinerary.arrivalDate, "HH:mm")), 1),
                          _createVNode("div", _hoisted_41, _toDisplayString(itinerary.destinationAirportCode), 1)
                        ], 2)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_42, [
                        _createVNode("div", {
                          class: 
                `${_ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-red-lp-100'}`
              
                        }, [
                          _createVNode("div", _hoisted_43, _toDisplayString(_ctx.formatDateNormal(itinerary.departureDate, "HH:mm")), 1),
                          _createVNode("div", _hoisted_44, _toDisplayString(itinerary.originAirportCode), 1)
                        ], 2),
                        _createVNode("div", _hoisted_45, [
                          _createVNode("div", {
                            class: 
                  `block text-sm font-medium ${
                    _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-gray-lp-600'
                  }`
                
                          }, _toDisplayString(itinerary.flightNo), 3),
                          _hoisted_46
                        ]),
                        _createVNode("div", {
                          class: 
                `${
                  _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-black-lp-200'
                }`
              
                        }, [
                          _createVNode("div", _hoisted_47, _toDisplayString(_ctx.formatDateNormal(itinerary.arrivalDate, "HH:mm")), 1),
                          _createVNode("div", _hoisted_48, _toDisplayString(itinerary.destinationAirportCode), 1)
                        ], 2),
                        (_ctx.flightData.arrivalDays)
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: 
                `text-sm font-bold self-baseline -mt-1 ml-1 ${
                  _ctx.statusUnavailable ? 'text-gray-lp-600' : 'text-red-lp-100'
                }`
              ,
                              style: {"align-self":"baseline"}
                            }, " +" + _toDisplayString(_ctx.flightData.arrivalDays) + " hari ", 3))
                          : _createCommentVNode("", true)
                      ]))
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_LpButton, {
        color: "white",
        textColor: "red-lp-100",
        title: "Cek ketersediaan",
        customClass: "border border-red-lp-100",
        outline: "",
        onClick: _ctx.onCheckAvailable,
        disabled: _ctx.disabledCheckAvailable
      }, null, 8, ["onClick", "disabled"])
    ])
  ], 2))
}